<template>
  <div class="mainWrapper">
    <div class="playerContainer" :style="{backgroundImage: `url(${playlist.cover})`, height:`${playerSize.height}px`}">
      <transition enterActiveClass="animated fadeIn" leaveActiveClass="animated fadeOut" appear>
        <PlayerMenu v-if="playerMenu"></PlayerMenu>
      </transition>
      <transition enterActiveClass="animated fadeIn" leaveActiveClass="animated fadeOut" appear>
        <div id="player"></div>
      </transition>
    </div>
    <transition enterActiveClass="animated fadeInUp" leaveActiveClass="animated fadeOutDown" appear mode="out-in">
      <Highlights v-if="highlights" @playVideo="playVideo($event)"></Highlights>
      <Plays v-if="plays" @playVideo="playVideo($event)"></Plays>
      <Players v-if="players" @playVideo="playVideo($event)"></Players>
    </transition>
  </div>
</template>

<script>
  import _ from 'lodash';
  import $ from 'jquery';
  import axios from 'axios';
  import { mapState, mapMutations } from 'vuex';
  import Highlights from './Highlights';
  import Plays from './Plays';
  import Players from './Players';
  import PlayerMenu from './PlayerMenu';
  import '../assets/css/toktv.skin.css';
  import { build } from '../../config/index';

  export default {
    name: 'Player',
    data() {
      return {
        sliderValue: 0,
        playerMenu: true,
        playerSize: {
          height: 0,
          width: 0,
        },
      };
    },
    methods: {
      handleResize() {
        this.setPlayerHeight();
      },
      ...mapMutations(['setHighlights', 'setInitialHighLight', 'setPlays', 'setPlayers', 'setPlaylist', 'appReady']),
      setPlayerHeight() {
        this.playerSize.width = document.querySelector('.playerContainer').offsetWidth;
        this.playerSize.height = Math.round((this.playerSize.width / 16) * 9);
      },
      playVideo(url) {
        clearInterval(window.menuInterval);
        this.setMenuInterval();
        this.setHighlights(false);
        window.jwplayer('player').setup({
          file: url,
          autostart: true,
          width: '100%',
          aspectratio: '16:9',
          stretching: 'exactfit',
          skin: {
            name: 'toktv',
          },
        });
        window.jwplayer('player').on('ready', () => {
          $('.jw-slider-time').insertAfter('.jw-icon-playback');
        });
        window.jwplayer('player').on('complete', () => {
          window.jwplayer('player').remove();
          this.playerMenu = true;
        });
      },
      closeHighlights() {
        this.highlights = false;
      },
      setMenuInterval() {
        window.menuInterval = setInterval(() => {
          if (!this.anyPanel && this.playerMenu) {
            this.playerMenu = false;
          }
        }, 3000);
      },
    },
    mounted() {
      const self = this;
      this.setPlayerHeight();
      axios.get(`${build.assetsPublicPath}static/endpoint.json`)
        .then((config) => {
          axios.get(config.data.endpoint)
            .then((response) => {
              const initialHighlight = parseInt(_.find(response.data.highlights, {
                default: true,
              }).name, 10);

              self.setPlaylist(response.data);
              self.setInitialHighLight(initialHighlight);
            })
            .then(() => {
              const img = new Image();
              img.src = self.playlist.cover;
              img.addEventListener('load', () => {
                self.appReady();
              }, false);
            });
          // .catch((error) => {
          //   console.warn(error);
          // });
          window.addEventListener('resize', this.handleResize);
          this.setMenuInterval();
          $('.playerContainer').mousemove(() => {
            if (!this.playerMenu) {
              this.playerMenu = true;
              clearInterval(window.menuInterval);
              this.setMenuInterval();
            }
          });
        });
    },
    components: {
      Highlights,
      PlayerMenu,
      Plays,
      Players,
    },
    computed: {
      ...mapState(['player', 'highlights', 'playlist', 'plays', 'players']),
      anyPanel() {
        return this.plays || this.players || this.highlights;
      },
    },
  };
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss" scoped>
  .mainWrapper {
    position: relative;
  }
  .Logo {
    width: 200px;
  }
  .playerContainer {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background-color: #fff;
    background-size: cover;
  }
  .animated {
    -webkit-animation-duration: .5s;
    animation-duration: .5s;
  }
</style>



// WEBPACK FOOTER //
// src/components/Player.vue